"use strict";

var _taggedTemplateLiteral = require("/home/circleci/poc-carditas-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    font-weight: 700;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    font-weight: 600;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    font-weight: 300;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ", ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.form = exports.action = exports.button = exports.supportForm = exports.support = exports.paragraph = exports.h6 = exports.h5 = exports.h4 = exports.h3 = exports.h2 = exports.h1 = exports.weight = void 0;

var _core = require("@emotion/core");

var typography = function typography(theme, name) {
  var family = theme["b".concat(name, "FontFamily")];
  var familyFallback = theme["b".concat(name, "FallbackFontFamily")];
  var size = theme["b".concat(name, "FontSize")];
  var weight = theme["b".concat(name, "FontWeight")];
  var height = theme["b".concat(name, "LineHeight")];
  return (0, _core.css)(_templateObject(), family, familyFallback, size, weight, height);
};

var weight = {
  light: function light() {
    return (0, _core.css)(_templateObject2());
  },
  semiBold: function semiBold() {
    return (0, _core.css)(_templateObject3());
  },
  bold: function bold() {
    return (0, _core.css)(_templateObject4());
  }
};
exports.weight = weight;

var h1 = function h1(theme) {
  return (0, _core.css)(_templateObject5(), typography(theme, 'Headingh1'));
};

exports.h1 = h1;

var h2 = function h2(theme) {
  return (0, _core.css)(_templateObject6(), typography(theme, 'Headingh2'));
};

exports.h2 = h2;

var h3 = function h3(theme) {
  return (0, _core.css)(_templateObject7(), typography(theme, 'Headingh3'));
};

exports.h3 = h3;

var h4 = function h4(theme) {
  return (0, _core.css)(_templateObject8(), typography(theme, 'Headingh4'));
};

exports.h4 = h4;

var h5 = function h5(theme) {
  return (0, _core.css)(_templateObject9(), typography(theme, 'Headingh5'));
};

exports.h5 = h5;

var h6 = function h6(theme) {
  return (0, _core.css)(_templateObject10(), typography(theme, 'Headingh6'));
};

exports.h6 = h6;

var paragraph = function paragraph(theme) {
  return (0, _core.css)(_templateObject11(), typography(theme, 'Textparagraph'));
};

exports.paragraph = paragraph;

var support = function support(theme) {
  return (0, _core.css)(_templateObject12(), typography(theme, 'Textsupport'));
};

exports.support = support;

var supportForm = function supportForm(theme) {
  return (0, _core.css)(_templateObject13(), typography(theme, 'Textsupportform'));
};

exports.supportForm = supportForm;

var button = function button(theme) {
  return (0, _core.css)(_templateObject14(), typography(theme, 'Labelbutton'));
};

exports.button = button;

var action = function action(theme) {
  return (0, _core.css)(_templateObject15(), typography(theme, 'Labelaction'));
};

exports.action = action;

var form = function form(theme) {
  return (0, _core.css)(_templateObject16(), typography(theme, 'Labelform'));
};

exports.form = form;